import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Activation from "@/components/landing/Activation";
import { useApp } from "@/context/AppProviders";

const ActivateHelp = () => {
  const { t } = useApp();
  const s = t.shop;
  return (
    <div className="min-h-screen bg-background text-foreground font-body antialiased">
      <Header />
      <main className="pt-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">
            {s.activateTitle}
          </h1>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground">
            {s.activateSubtitle}
          </p>
        </div>
        <Activation />
      </main>
      <Footer />
    </div>
  );
};

export default ActivateHelp;
